var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-grid"},_vm._l((_vm.items),function(item){return _c('div',{key:item.label,staticClass:"stat-card"},[_c('strong',[_vm._v(_vm._s(_vm.format(item.value)))]),_c('span',[_vm._v(_vm._s(item.label))]),(item.note)?_c('small',[_vm._v(_vm._s(item.note))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }